var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pen_1_",
    "data-name": "pen (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.354,
    height: 33.365,
    viewBox: "0 0 33.354 33.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85446",
    "data-name": "Path 85446",
    d: "M.495,361.711a.976.976,0,0,0,.938,1.245.91.91,0,0,0,.267-.039l9.11-2.6L3.095,352.6Zm0,0",
    transform: "translate(-0.427 -329.624)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85447",
    "data-name": "Path 85447",
    d: "M1.006,362.145a1,1,0,0,1-.964-1.284l2.62-9.162,7.794,7.794-9.175,2.613a.985.985,0,0,1-.274.039Zm1.681-10.329L.1,360.874a.94.94,0,0,0,.906,1.2.905.905,0,0,0,.261-.039l9.058-2.587Zm0,0",
    transform: "translate(0 -328.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85448",
    "data-name": "Path 85448",
    d: "M349.689,5.5,345.551,1.36a2.942,2.942,0,0,0-4.151-.006l-2.072,2.072,8.283,8.283,2.072-2.072a2.942,2.942,0,0,0,.006-4.138Zm0,0",
    transform: "translate(-317.216 -0.467)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85449",
    "data-name": "Path 85449",
    d: "M347.058,11.286,338.73,2.958,340.822.866a2.958,2.958,0,0,1,4.184,0L349.144,5a2.958,2.958,0,0,1,0,4.184Zm-8.237-8.328,8.237,8.237L349.1,9.149a2.894,2.894,0,0,0,0-4.092L344.966.912a2.9,2.9,0,0,0-4.1,0Zm0,0",
    transform: "translate(-316.657 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85450",
    "data-name": "Path 85450",
    d: "M57.8,83.561,74.775,66.59l8.285,8.285L66.09,91.846Zm0,0",
    transform: "translate(-54.038 -62.251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_85451",
    "data-name": "Path 85451",
    d: "M65.367,91.247l-8.335-8.335L74.053,65.9l8.328,8.328ZM57.13,82.913l8.237,8.237L82.29,74.226l-8.237-8.237Zm0,0",
    transform: "translate(-53.315 -61.604)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d7b5ede8d4f82ebb35c9ff4a0b79e15e.svg";
export { ForwardRef as ReactComponent };